export const environment = {
  production: false,
  mockup: false,

  CPS2_DOMAIN: 'https://cps-staging.pharmacists.ca',
  CPHA_AUTH_ENDPOINT: 'https://hub-staging.pharmacists.ca/cpha-auth',
  COMMONS_API_ENDPOINT: 'https://hub-staging.pharmacists.ca/cpha-commons-rest-ws',
  CPS_URL: 'https://cps-staging.pharmacists.ca/assets/tokens-receiver.html',
  HUB_ORIGIN: 'https://hub-staging.pharmacists.ca'
};
